/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

// Modules
import localStorage from './modules/localStorage';
import account from './modules/account';
import auth from './modules/auth';
import unitTypes from './modules/unitTypes';
import units from './modules/units';
import filters from './modules/filters';
import panoramas from './modules/panoramas';
import exteriors from './modules/exteriors';
import sunstudy from './modules/sunstudy';
import project from './modules/project';
import service from './modules/service';
import imageProcessing from './modules/imageProcessing';
import nativePanorama from './modules/native-panorama';
import navigation from "@/store/modules/navigation";
import plugins from './plugins';

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    localStorage,
    account,
    auth,
    units,
    unitTypes,
    filters,
    project,
    exteriors,
    sunstudy,
    panoramas,
    service,
    imageProcessing,
    nativePanorama,
    navigation,
  },

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  plugins: debug ? plugins.concat(createLogger()) : plugins,
});
